import ImageCarousel from "../../Components/Common/Carousel";
import EstandeSemImagem from "../../assets/images/estande_sem_imagem.png";
import DimensoesTable from "../ComponenteCompartilhado/DimensoesTable";

const SidebarEstandeReservadoNovo = ({
  selectedEstandeInfo,
  corPrincipal,
  corSecundaria,
  isMobile,
  onToggle,
  isOpen,
  setOpenMobile
}) => {

  return (
   <div style={{ "--primary-color": corPrincipal, "--second-color": corSecundaria }}>
    {!!onToggle && (
      <div className={`sidebar-backdrop ${isOpen ? "is-visible" : ""}`} onClick={onToggle} />
    )}
      
      <div className="sidebar-header">
        {isMobile && typeof setOpenMobile === "function" && (
          <button
            onClick={() => setOpenMobile(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              background: "transparent",
              border: "none",
              fontSize: 26,
              color: "white",
              zIndex: 20,
            }}
            aria-label="Fechar"
            title="Fechar"
          >
            ×
          </button>
        )}

        <div className="sidebar-topo-estande" style={{ background: corPrincipal}}>
          <div className="mt-2">
            <h3 style={{ color: 'white'}} >{selectedEstandeInfo?.nome || ""} (Reservado)</h3>
            <p style={{ color: 'white'}}>{selectedEstandeInfo?.pavilhao.length > 0 ? selectedEstandeInfo?.pavilhao[0].nome : ''}</p>
          </div>
        </div>
      </div>
      
      <div className="sidebar-body">
        <div className="relative" style={{ padding: "5px" }}>
          <ImageCarousel 
            images={selectedEstandeInfo?.imagens || []} 
            defaultImage={EstandeSemImagem}
            corFundo={corPrincipal}
          />
        </div>

        <DimensoesTable selectedEstandeInfo={selectedEstandeInfo} corPrincipal={corPrincipal} />

        <div style={{ 
          // padding: "1.5rem", 
          textAlign: "center",
          marginTop: "1rem"
        }}>
          <div style={{
            background: "#f8f9fa",
            padding: "1rem",
            borderRadius: "8px",
            border: `1px solid ${corPrincipal}`
          }}>
            <p style={{ 
              color: corPrincipal,
              fontWeight: "500",
              marginBottom: "0"
            }}>
              Este espaço já foi reservado.
            </p>
            
          </div>
        </div>
      </div>
    
    </div>
  );
};

export default SidebarEstandeReservadoNovo;